"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableLoadingBody = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var styled_components_1 = __importStar(require("styled-components"));
var loading = (0, styled_components_1.keyframes)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  0% {\n    opacity: 0.3;\n  }\n  50% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0.3;\n  }\n"], ["\n  0% {\n    opacity: 0.3;\n  }\n  50% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0.3;\n  }\n"])));
exports.TableLoadingBody = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  animation: ", " 1500ms linear;\n  animation-iteration-count: infinite;\n  background-image: repeating-linear-gradient(\n    180deg,\n    ", " 0px,\n    ", " 60px,\n    transparent 60px,\n    transparent 120px\n  );\n  width: 100%;\n  height: 220px;\n"], ["\n  animation: ", " 1500ms linear;\n  animation-iteration-count: infinite;\n  background-image: repeating-linear-gradient(\n    180deg,\n    ", " 0px,\n    ", " 60px,\n    transparent 60px,\n    transparent 120px\n  );\n  width: 100%;\n  height: 220px;\n"])), loading, core_ui_1.colors.brand[100], core_ui_1.colors.brand[100]);
var templateObject_1, templateObject_2;
